var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReservationService } from '../reservation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
export class ReservationUserPageComponent {
    constructor(route, router, reservationService, modalService, snackBar, translate) {
        this.route = route;
        this.router = router;
        this.reservationService = reservationService;
        this.modalService = modalService;
        this.snackBar = snackBar;
        this.translate = translate;
        this.welcomeMsg = '';
        this.cancellationText = '';
        this.creditCardGuarantee = false;
        const token = this.route.snapshot.paramMap.get('token');
        // Check if token is valid
        this.reservationService.checkUserToken(token).subscribe(reservation => {
            this.reservation = reservation;
            this.creditCardGuarantee = this.reservation.payment && this.reservation.payment.paymentType ? true : false;
            this.generateCancellationText();
            const { client, userLang, guestData } = this.reservation;
            const isGermanUser = userLang === 'de';
            const requiresFormalLang = isGermanUser && client.pronominalForm === 'sie';
            const activeLanguage = requiresFormalLang ? 'de-Formal' : isGermanUser ? 'de-DE' : userLang;
            console.log(activeLanguage);
            this.translate.use(activeLanguage);
            this.welcomeMsg = this.translate.instant('reservationInfoTemplate.greeting', {
                name: requiresFormalLang ? guestData.name : guestData.firstName
            });
        }, err => this.router.navigate(['/404']));
    }
    ngOnInit() { }
    cancelReservation() {
        let message = `Bist du dir sicher dass du deine Reservierung stornieren möchtest?`;
        if (this.reservation.paymentsTemp && this.reservation.paymentsTemp.netto) {
            this.reservationService.getCCChargedAmount(this.reservation.paymentsTemp.id).subscribe((result) => {
                if (result && result.chargedAmount) {
                    message = `Bist du dir sicher dass du deine Reservierung stornieren möchtest? Es fällt eine Stornierungsgebühr von ${result.chargedAmount} € an.`;
                    this.cancelReservationModal(message, true);
                }
                else {
                    this.cancelReservationModal(message);
                }
            });
        }
        else {
            this.cancelReservationModal(message);
        }
    }
    cancelReservationModal(message, isCCPayment = false) {
        const modalRef = this.modalService.open(ConfirmModalComponent);
        modalRef.componentInstance.title = 'Reservierung stornieren';
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.showInfo = false;
        modalRef.componentInstance.buttonText = isCCPayment ? 'Kostenpflichtig stornieren' : 'Ja';
        modalRef.result.then(result => {
            if (result === 'ok') {
                this.reservationService.cancelReservation(this.reservation.id).subscribe(res => {
                    this.reservation.status = res.status;
                    this.updateReservation(res.status.toUpperCase(), this.reservation);
                    if (this.reservation.paymentsTemp && this.reservation.paymentsTemp.netto) {
                        this.reservationService
                            .chargeNoShowAmount(this.reservation.paymentsTemp.id)
                            .subscribe((response) => {
                            console.log(response);
                        });
                    }
                    this.snackBar.open('Reservierung erfolgreich storniert', '', {
                        duration: 2000,
                        panelClass: ['snackbar-success']
                    });
                }, err => {
                    this.snackBar.open('Es ist ein Fehler aufgetreten: ' + err.error.msg, '', {
                        duration: 2000,
                        panelClass: ['snackbar-error']
                    });
                });
            }
        }, () => { });
    }
    updateReservation(status, reservation) {
        const referrer = reservation.referrer ? reservation.referrer : '';
        if (referrer && referrer.includes('Reservierung mit Google')) {
            this.reservationService.getupdateGoogleReseration(status, reservation).subscribe((settings) => {
                if (settings) {
                    console.log('Canceled google reservation');
                }
            });
        }
    }
    generateCancellationText() {
        return __awaiter(this, void 0, void 0, function* () {
            this.cancellationText = yield this.reservationService.generateCancellationText(this.reservation);
        });
    }
}
